module.exports = __webpack_public_path__ + "static/img/商业智能-3.199c163b.png";